// Core Web Vitals (RUM): collect LCP/INP/CLS/FCP/TTFB in the browser and beacon
// each to the backend (/api/telemetry/vitals), which records them as OpenTelemetry
// histograms. Uses navigator.sendBeacon so reports survive tab close/navigation;
// fire-and-forget, never blocks the UI, and sends no PII. Same-origin, so no CSRF
// concern (the endpoint is unauthenticated and only records a bounded metric).
import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from "web-vitals";

const ENDPOINT = "/api/telemetry/vitals";

function report(metric: Metric) {
  const body = JSON.stringify({
    name: metric.name, // "LCP" | "INP" | "CLS" | "FCP" | "TTFB"
    value: metric.value,
    rating: metric.rating, // "good" | "needs-improvement" | "poor"
  });
  // Prefer sendBeacon (queued by the browser, survives unload); fall back to a
  // keepalive fetch where it is unavailable.
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "application/json" }));
      return;
    }
  } catch {
    /* fall through to fetch */
  }
  void fetch(ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true,
    credentials: "same-origin",
  }).catch(() => {
    /* RUM is best-effort; never surface an error to the user */
  });
}

// initWebVitals registers the collectors. Each fires once its value is final
// (INP/CLS on interaction/hidden), so this is cheap and safe to call once at boot.
export function initWebVitals() {
  onLCP(report);
  onINP(report);
  onCLS(report);
  onFCP(report);
  onTTFB(report);
}
